import React, { useState } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  TextField,
  Typography,
  CircularProgress,
} from "@mui/material";
import HandleSingleWasteInventory from "../Functions/HandleSingleWasteInventory";

const SingleWasteDialog = ({
  open,
  onClose,
  inventoryId,
  instanceIndex,
  maxAmount,
  token,
  fetchInventory,
}) => {
  const [quantity, setQuantity] = useState("");
  const [loading, setLoading] = useState(false);

  const handleWaste = async () => {
    setLoading(true);
    await HandleSingleWasteInventory({
      inventoryId,
      instanceIndex,
      quantity: Number(quantity),
      token,
      fetchInventory,
      onClose,
    });
    setLoading(false);
  };

  return (
    <Dialog open={open} onClose={onClose}>
      <DialogTitle>Waste Inventory</DialogTitle>
      <DialogContent>
        <Typography>Enter quantity to waste (max: {maxAmount})</Typography>
        <TextField
          type="number"
          value={quantity}
          onChange={(e) => setQuantity(e.target.value)}
          inputProps={{
            min: 1,
            max: maxAmount,
          }}
          fullWidth
          autoFocus
          margin="dense"
        />
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} disabled={loading}>
          Cancel
        </Button>
        <Button
          onClick={handleWaste}
          disabled={
            loading ||
            !quantity ||
            isNaN(quantity) ||
            Number(quantity) <= 0 ||
            Number(quantity) > maxAmount
          }
          variant="contained"
          color="error"
        >
          {loading ? (
            <CircularProgress size={24} color="inherit" />
          ) : (
            "Confirm Waste"
          )}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default SingleWasteDialog;
